import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lifedi-symbol-skill-tree',
  templateUrl: './symbol-skill-tree.component.html',
  styleUrls: ['./symbol-skill-tree.component.scss']
})
export class SymbolSkillTreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
